/* Stefan Diamonds — minimal front-end JS
   - Mobile drawer: open/close (Escape closes) + drill-down sub-levels
   - Announcement bar rotator
   - Carousels, header transparency, hero video source swap
   Note: desktop nav dropdowns are CSS-only (:hover + :focus-within).
*/
(function () {
  'use strict';

  // Drawer ---------------------------------------------------------------
  var drawer = document.querySelector('[data-sd-drawer]');
  var openBtn = document.querySelector('[data-sd-drawer-open]');
  var closeBtns = document.querySelectorAll('[data-sd-drawer-close]');

  function resetDrawerLevels() {
    if (!drawer) return;
    drawer.querySelectorAll('.sd-drawer__level--sub.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    // Collapse back to the root level once the panel has slid out.
    setTimeout(resetDrawerLevels, 300);
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });

  // Product variant selection: pills update price + add-to-bag variant -------
  (function () {
    var dataEl = document.querySelector('[data-sd-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var priceEl = document.querySelector('[data-sd-price]');
    var idInput = document.querySelector('[data-sd-variant-id]');
    var addBtn = document.querySelector('[data-sd-add]');
    var skuEl = document.querySelector('[data-sd-sku]');
    var groups = document.querySelectorAll('.sd-opt');

    function update() {
      var chosen = [];
      groups.forEach(function (g) {
        var sel = g.querySelector('.sd-pill.is-selected');
        chosen.push(sel ? sel.getAttribute('data-sd-value') : null);
      });
      var match = variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      if (priceEl) {
        // match.price / match.was are money strings rendered by our own Liquid.
        if (match.was) {
          priceEl.innerHTML = '<s class="sd-price__was">' + match.was + '</s> <span class="sd-price__now">' + match.price + '</span>';
        } else {
          priceEl.textContent = match.price;
        }
      }
      if (skuEl && match.sku) skuEl.textContent = match.sku;
      if (idInput) idInput.value = match.id;
      // Jump the gallery to this variant's linked media (Lisa 2026-07-25).
      if (typeof match.media === 'number') {
        document.dispatchEvent(new CustomEvent('sd:gallery-goto', { detail: match.media }));
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
    }

    groups.forEach(function (group) {
      group.querySelectorAll('.sd-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.sd-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          update();
        });
      });
    });
    update();
  })();

  // Drawer drill-down: a parent row opens its sub-level; Back returns to root.
  document.querySelectorAll('[data-sd-drawer-open-sub]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = document.querySelector('[data-sd-drawer-sub="' + btn.getAttribute('data-sd-drawer-open-sub') + '"]');
      if (sub) sub.classList.add('is-active');
    });
  });
  document.querySelectorAll('[data-sd-drawer-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = btn.closest('.sd-drawer__level--sub');
      if (sub) sub.classList.remove('is-active');
    });
  });

  // Announcement rotator -------------------------------------------------
  var rotator = document.querySelector('[data-sd-announcement]');
  if (rotator) {
    var items = rotator.querySelectorAll('[data-sd-announcement-item]');
    if (items.length > 1) {
      var i = 0;
      items.forEach(function (el, idx) { el.style.display = idx === 0 ? 'inline-block' : 'none'; });
      setInterval(function () {
        items[i].style.display = 'none';
        i = (i + 1) % items.length;
        items[i].style.display = 'inline-block';
      }, 4500);
    }
  }

  // Desktop dropdowns are CSS-only (:hover + :focus-within); the parent link
  // navigates on click. Mobile sub-menus use native <details> accordions.
  // No JS needed for either — so nothing to wire up here.

  // ESC closes the mobile drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Carousels ----------------------------------------------------------
  document.querySelectorAll('[data-sd-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-sd-carousel-track]');
    var prev = car.querySelector('[data-sd-carousel-prev]');
    var next = car.querySelector('[data-sd-carousel-next]');
    var pTrack = car.querySelector('[data-sd-carousel-progress]');
    var pFill = car.querySelector('[data-sd-carousel-progress-fill]');
    if (!track) return;

    function step() {
      var first = track.querySelector('.sd-carousel__item');
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      if (prev && next) {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }
      if (pTrack && pFill) {
        var maxScroll = track.scrollWidth - track.clientWidth;
        var pW = pTrack.clientWidth;
        if (pW > 0 && track.scrollWidth > 0) {
          var visRatio = Math.min(1, track.clientWidth / track.scrollWidth);
          var fillPx = Math.max(20, visRatio * pW);
          var sRatio = maxScroll > 0 ? Math.max(0, Math.min(1, track.scrollLeft / maxScroll)) : 0;
          var tx = sRatio * Math.max(0, pW - fillPx);
          pFill.style.width = fillPx + 'px';
          pFill.style.transform = 'translateX(' + tx + 'px)';
        }
      }
    }
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // Header transparency state -------------------------------------------
  // On homepage, the header is transparent while we're at the top of the
  // page (over the hero) and becomes its opaque ivory-glass self as soon
  // as the user scrolls. Affirmative class pattern:
  //   - .is-transparent on header (added when at top)
  //   - .sd-at-top on body (announcement bar uses this)
  // When the class is removed, the base .sd-header/ .sd-announcement styles
  // apply (opaque header, visible announcement). Non-home pages are
  // unaffected because the CSS is template-index-scoped.
  var headerEl = document.querySelector('.sd-header');
  if (headerEl) {
    var scrollThreshold = 30;
    var headerTicking = false;
    var updateHeaderState = function () {
      var atTop = (window.scrollY || document.documentElement.scrollTop || 0) <= scrollThreshold;
      headerEl.classList.toggle('is-transparent', atTop);
      document.body.classList.toggle('sd-at-top', atTop);
    };
    updateHeaderState();
    var onScroll = function () {
      if (headerTicking) return;
      headerTicking = true;
      requestAnimationFrame(function () {
        updateHeaderState();
        headerTicking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', updateHeaderState);
    window.addEventListener('resize', updateHeaderState);
  }

  // Pinned announcement bar height ---------------------------------------
  // On the homepage the announcement bar is pinned (fixed) at the very top and
  // the header floats just beneath it. Measure the bar's real height and expose
  // it as --sd-ann-h so the fixed header's top offset stays flush even when a
  // message wraps to two lines on a narrow screen.
  var annBar = document.querySelector('.sd-announcement');
  if (annBar) {
    var syncAnnHeight = function () {
      document.body.style.setProperty('--sd-ann-h', annBar.offsetHeight + 'px');
    };
    syncAnnHeight();
    window.addEventListener('load', syncAnnHeight);
    window.addEventListener('resize', syncAnnHeight);
    if (window.ResizeObserver) {
      new ResizeObserver(syncAnnHeight).observe(annBar);
    }
  }

  // Hero — reload <source media> when viewport crosses 768px -----------
  // <video><source media="..."></video> only picks a source once on load.
  // When the theme editor toggles desktop/mobile (or the browser is
  // resized across 768px), we need to call video.load() to re-evaluate.
  var heroVideos = document.querySelectorAll('.sd-hero video');
  if (heroVideos.length && window.matchMedia) {
    var mq = window.matchMedia('(min-width: 768px)');
    var lastMatch = mq.matches;
    var swapSource = function () {
      if (mq.matches === lastMatch) return;
      lastMatch = mq.matches;
      heroVideos.forEach(function (v) {
        try {
          v.load();
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } catch (err) {}
      });
    };
    if (mq.addEventListener) mq.addEventListener('change', swapSource);
    else if (mq.addListener) mq.addListener(swapSource);
  }
})();

/* Cart — AJAX drawer + cart page via the Section Rendering API ----------- */
(function () {
  'use strict';
  var DRAWER_ID = 'shopify-section-cart-drawer';
  var CART_ID = 'shopify-section-main-cart';

  function openCart() {
    if (!document.getElementById(DRAWER_ID)) return;
    document.body.classList.add('sd-cart-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    document.body.classList.remove('sd-cart-open');
    document.body.style.overflow = '';
  }

  // Open from the header bag icon; the href to /cart stays as a no-JS fallback.
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sd-cart-open]');
    if (opener) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-sd-cart-close]')) { closeCart(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('sd-cart-open')) closeCart();
  });

  function sectionsToRender() {
    var names = [];
    if (document.getElementById(DRAWER_ID)) names.push('cart-drawer');
    if (document.getElementById(CART_ID)) names.push('main-cart');
    return names;
  }
  function swapSection(name, html) {
    var id = 'shopify-section-' + name;
    var current = document.getElementById(id);
    if (!current || !html) return;
    var incoming = new DOMParser().parseFromString(html, 'text/html').getElementById(id);
    if (incoming) current.innerHTML = incoming.innerHTML;
  }
  function applySections(sections) {
    if (sections) {
      Object.keys(sections).forEach(function (name) { swapSection(name, sections[name]); });
    }
    syncCount();
  }
  // Mirror the freshly rendered drawer count to the header badge.
  function syncCount() {
    var src = document.querySelector('[data-sd-cart-drawer] [data-sd-cart-count]');
    var n = src ? parseInt(src.textContent, 10) : NaN;
    if (isNaN(n)) return;
    var badge = document.querySelector('[data-sd-cart-badge]');
    if (badge) { badge.textContent = n; badge.hidden = n === 0; }
  }

  function postCart(url, body) {
    body.sections = sectionsToRender();
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Add to cart from the product form (AJAX, then open the drawer).
  var addBtn = document.querySelector('[data-sd-add]');
  var productForm = addBtn ? addBtn.closest('form') : null;
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idField = productForm.querySelector('[name="id"]');
      if (!idField || !idField.value) return;
      addBtn.disabled = true;
      postCart('/cart/add.js', { items: [{ id: idField.value, quantity: 1 }] })
        .then(function (data) {
          if (data && data.sections) applySections(data.sections);
          openCart();
        })
        .catch(function () { productForm.submit(); })
        .then(function () { addBtn.disabled = false; });
    });
  }

  // Quantity steppers + remove — delegated so they survive section re-render.
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-sd-qty-up]');
    var down = e.target.closest('[data-sd-qty-down]');
    var rm = e.target.closest('[data-sd-cart-remove]');
    if (!up && !down && !rm) return;
    var itemEl = e.target.closest('[data-sd-cart-item]');
    if (!itemEl) return;
    var line = parseInt(itemEl.getAttribute('data-line'), 10);
    var qty;
    if (rm) {
      qty = 0;
    } else {
      var input = itemEl.querySelector('[data-sd-qty-input]');
      var cur = parseInt(input && input.value, 10) || 1;
      qty = up ? cur + 1 : Math.max(0, cur - 1);
    }
    itemEl.style.opacity = '0.5';
    postCart('/cart/change.js', { line: line, quantity: qty })
      .then(function (data) {
        // On an availability/stock error Shopify returns {status: 4xx} with no
        // sections; leave the cart unchanged and just un-dim the row.
        if (data && data.sections) applySections(data.sections);
        else itemEl.style.opacity = '';
      })
      .catch(function () { itemEl.style.opacity = ''; });
  });

  // Gift message — toggle the panel, persist the note as the cart note.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sd-gift-toggle]');
    if (!t) return;
    var panel = t.parentElement.querySelector('[data-sd-gift-panel]');
    if (!panel) return;
    var show = panel.hidden;
    panel.hidden = !show;
    t.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show) { var ta = panel.querySelector('[data-sd-gift-note]'); if (ta) ta.focus(); }
  });
  document.addEventListener('change', function (e) {
    var ta = e.target.closest('[data-sd-gift-note]');
    if (!ta) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: ta.value })
    });
  });
})();

/* Product image gallery — swipe + thumbnails + arrows -------------------- */
(function () {
  'use strict';
  document.querySelectorAll('[data-sd-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-sd-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.sd-gallery__slide');
    if (slides.length < 2) return;
    var thumbs = gallery.querySelectorAll('[data-sd-gallery-thumb]');
    var dots = gallery.querySelectorAll('.sd-gallery__dot');
    var prev = gallery.querySelector('[data-sd-gallery-prev]');
    var next = gallery.querySelector('[data-sd-gallery-next]');

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function setActive(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      // Pause any product video the user scrolled away from.
      slides.forEach(function (s, idx) {
        if (idx !== i) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-sd-gallery-thumb'), 10));
      });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { setActive(current()); ticking = false; });
    }, { passive: true });

    // Variant pills dispatch this when the selected variant has linked media.
    document.addEventListener('sd:gallery-goto', function (e) {
      goTo(e.detail);
    });

    setActive(0);
  });

  // POA "Enquire Now" modal: open/close ------------------------------------
  (function () {
    var modal = document.querySelector('[data-sd-enquire-modal]');
    if (!modal) return;
    function open() { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); }
    document.querySelectorAll('[data-sd-enquire-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-sd-enquire-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  })();

  // Collection toolbar: filter/sort selects submit their form on change -----
  (function () {
    document.querySelectorAll('[data-sd-auto-submit]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        if (form) form.submit();
      });
    });
    // Mobile: "Filter" button reveals/hides the facet panel.
    document.querySelectorAll('[data-sd-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        var panel = form && form.querySelector('[data-sd-filter-panel]');
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();
})();

/* "You may also love" — swap the same-collection fallback for Shopify's
   Product Recommendations (related intent) once the API responds ---------- */
(function () {
  'use strict';
  var holder = document.querySelector('[data-sd-recommendations]');
  if (!holder) return;
  var url = holder.getAttribute('data-sd-recommendations-url');
  if (!url) return;
  fetch(url)
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var incoming = doc.querySelector('[data-sd-recommendations]');
      // Only swap when the API actually returned recommendations; otherwise
      // keep the server-rendered same-collection fallback.
      if (incoming && incoming.querySelector('.sd-product-card')) {
        holder.innerHTML = incoming.innerHTML;
      }
    })
    .catch(function () { /* fallback stays */ });
})();

/* Collection — infinite scroll (Lisa 2026-07-25) --------------------------
   Watches a sentinel above the pagination nav; when it nears the viewport,
   fetches the next page, appends its product cards to the grid, and repeats
   until there are no more pages. Pagination stays as the no-JS fallback. */
(function () {
  'use strict';
  var grid = document.querySelector('[data-sd-infinite-grid]');
  var sentinel = document.querySelector('[data-sd-infinite-sentinel]');
  var pagination = document.querySelector('[data-sd-pagination]');
  if (!grid || !sentinel) return;
  var nextLink = pagination && pagination.querySelector('[data-sd-next]');
  var nextUrl = nextLink ? nextLink.getAttribute('href') : null;
  if (!nextUrl) { sentinel.classList.add('is-done'); return; }
  if (!('IntersectionObserver' in window)) return; // pagination fallback

  pagination.classList.add('is-infinite-hidden');
  var loading = false;

  function loadNext() {
    if (loading || !nextUrl) return;
    loading = true;
    sentinel.classList.add('is-loading');
    fetch(nextUrl)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incomingGrid = doc.querySelector('[data-sd-infinite-grid]');
        if (incomingGrid) {
          Array.prototype.slice.call(incomingGrid.children).forEach(function (card) {
            grid.appendChild(document.adoptNode(card));
          });
        }
        var incomingNext = doc.querySelector('[data-sd-next]');
        nextUrl = incomingNext ? incomingNext.getAttribute('href') : null;
        if (!nextUrl) {
          observer.disconnect();
          sentinel.classList.add('is-done');
        }
      })
      .catch(function () {
        // Network hiccup: stop auto-loading, reveal pagination as fallback.
        observer.disconnect();
        sentinel.classList.add('is-done');
        if (pagination) pagination.classList.remove('is-infinite-hidden');
      })
      .then(function () {
        loading = false;
        sentinel.classList.remove('is-loading');
      });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { if (entry.isIntersecting) loadNext(); });
  }, { rootMargin: '600px 0px' });
  observer.observe(sentinel);
})();
